import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1)
const _hoisted_2 = { class: "modal-card" }
const _hoisted_3 = { class: "modal-card-head" }
const _hoisted_4 = { class: "modal-card-title" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = { class: "modal-card-foot" }

import { useConfirmDialog } from '@vueuse/core';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ModalCard',
  emits: ['onReveal', 'onConfirm', 'onCancel'],
  setup(__props, { expose: __expose, emit: __emit }) {

  const { isRevealed, reveal, confirm, cancel, onReveal, onConfirm, onCancel } =
    useConfirmDialog();

  __expose({ reveal, confirm, cancel });
  const emit = __emit;

  onReveal(() => emit('onReveal'));
  onConfirm(() => emit('onConfirm'));
  onCancel(() => emit('onCancel'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal", { 'is-active': _unref(isRevealed) }])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, [
          _renderSlot(_ctx.$slots, "title")
        ]),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(cancel) && _unref(cancel)(...args)))
        })
      ]),
      _createElementVNode("section", _hoisted_5, [
        _renderSlot(_ctx.$slots, "content")
      ]),
      _createElementVNode("footer", _hoisted_6, [
        _renderSlot(_ctx.$slots, "footer")
      ])
    ])
  ], 2))
}
}

})